import React from "react";
import { Table } from "semantic-ui-react";
import PropTypes from "prop-types";
import {
  getDescripcionMoneda,
  getNombreMoneda,
} from "../../../../app/util/textCodeUtils";
import {
  fomartTasa,
  fomartPlazoDPF,
  formatMoney,
} from "../../../../app/util/formatUtils";
import { NOMBRE_TIPO_CUENTA_DPF } from "../../../../app/infrastructure/appConstants";

const AperturarCuentaDPFResumen = ({
  codigoMoneda,
  numeroCuenta,
  plazo,
  importe,
  cuentaCargo,
  tasaInteres,
  interesRecibir,
  aplicaTipoCambio,
  tipoCambio,
  periodoPago,
  formaPago,
  importeDebitarValidado,
  monedaDebitarValidado,
}) => {
  return (
    <>
      <Table singleLine>
        <Table.Body>
          <Table.Row>
            <Table.Cell width="7">Tipo de cuenta:</Table.Cell>
            <Table.Cell width="9">{NOMBRE_TIPO_CUENTA_DPF}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Moneda:</Table.Cell>
            <Table.Cell>{getDescripcionMoneda(codigoMoneda)}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Importe:</Table.Cell>
            <Table.Cell>{`${formatMoney(importe)}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Plazo:</Table.Cell>
            <Table.Cell>{`${fomartPlazoDPF(plazo)}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Tasa:</Table.Cell>
            <Table.Cell>{`${fomartTasa(tasaInteres)}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Interés a recibir:</Table.Cell>
            <Table.Cell>{`${formatMoney(interesRecibir)}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Periodo de pago:</Table.Cell>
            <Table.Cell>{periodoPago}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Forma de pago:</Table.Cell>
            <Table.Cell>{formaPago}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Cuenta cargo:</Table.Cell>
            <Table.Cell>{`${cuentaCargo}`}</Table.Cell>
          </Table.Row>
          {numeroCuenta && (
            <Table.Row>
              <Table.Cell>Número Cuenta:</Table.Cell>
              <Table.Cell>{numeroCuenta}</Table.Cell>
            </Table.Row>
          )}
          {aplicaTipoCambio === true && (
            <>
              <Table.Row active>
                <Table.Cell>Información adicional</Table.Cell>
                <Table.Cell />
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tipo de cambio:</Table.Cell>
                <Table.Cell>{tipoCambio}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Monto a debitar:</Table.Cell>
                <Table.Cell>{`${getNombreMoneda(
                  monedaDebitarValidado
                )} ${formatMoney(importeDebitarValidado)}`}</Table.Cell>
              </Table.Row>
            </>
          )}
        </Table.Body>
      </Table>
    </>
  );
};
AperturarCuentaDPFResumen.propTypes = {
  codigoMoneda: PropTypes.string.isRequired,
  tasaInteres: PropTypes.number.isRequired,
  plazo: PropTypes.number.isRequired,
  numeroCuenta: PropTypes.string,
  aplicaTipoCambio: PropTypes.bool.isRequired,
  tipoCambio: PropTypes.number,
  periodoPago: PropTypes.string.isRequired,
  formaPago: PropTypes.string.isRequired,
  importeDebitarValidado: PropTypes.number.isRequired,
  monedaDebitarValidado: PropTypes.string.isRequired,
};

export default AperturarCuentaDPFResumen;
